import React from "react";
import CrudTable from "../../components/Table/CrudTable/CrudTable";
import { useSelector } from "react-redux";
import MedidaModal from "./Medida";
import { MEDIDA } from "store/constants";
import Header from "../../components/Header/Header";

const TabTareas = () => {
	const data = useSelector(state => state[MEDIDA.name]);

	const columns = React.useMemo(
		() => [
			{
				Header: "Medida",
				accessor: "nombre"
			}
		],
		[]
	);

	return (
		<>
			<Header title="Medidas" video time="5:35" />

			<CrudTable
				data={data.data}
				status={data.view}
				columns={columns}
				type={MEDIDA}
				modal={MedidaModal}
				filters={columns}
				options={{ orderBy: true }}
			/>
		</>
	);
};

export default TabTareas;
